import React from 'react';
import {
  ClockCircleOutlined,
  PlayCircleOutlined,
  CheckCircleOutlined,
  IssuesCloseOutlined,
  QuestionCircleOutlined,
  ScheduleOutlined,
  UserOutlined,
} from '@ant-design/icons';

/* eslint-disable camelcase */
const statusConfig = {
  open: {
    icon: <ClockCircleOutlined style={{ color: '#6B778C' }} />,
  },
  taken: {
    icon: <UserOutlined style={{ color: '#0052CC' }} />,
  },
  clarification: {
    icon: <QuestionCircleOutlined style={{ color: '#FF8B00' }} />,
  },
  on_roadmap: {
    icon: <ScheduleOutlined style={{ color: '#5243AA' }} />,
  },
  in_progress: {
    icon: <PlayCircleOutlined style={{ color: '#0052CC' }} />,
  },
  done: {
    icon: <CheckCircleOutlined style={{ color: '#36B37E' }} />,
  },
  closed: {
    icon: <IssuesCloseOutlined style={{ color: '#6B778C' }} />,
  },
};
/* eslint-enable camelcase */

export default statusConfig;
